const BASKET_COLUMNS_WIDTH_MAP = {
  0: 250,
  1: 65,
};

export default BASKET_COLUMNS_WIDTH_MAP;
